export default __webpack_public_path__ + "static/media/deco-3.da6eec2b.webp";